import { render, staticRenderFns } from "./OfferParams.vue?vue&type=template&id=bb22161c&"
import script from "./OfferParams.vue?vue&type=script&lang=js&"
export * from "./OfferParams.vue?vue&type=script&lang=js&"
import style0 from "./OfferParams.vue?vue&type=style&index=0&id=bb22161c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports